import ModalButton from "../ModalButton";
import SimpleModal from "../SimpleModal";
import {faInfo} from "@fortawesome/free-solid-svg-icons/faInfo";
import myCircleInfo from "../../../customicons/myCircleInfo";


const InfoModal = ({modalTitle, children, buttonToolTip}) => {
    return <ModalButton icon={myCircleInfo} toolTip={buttonToolTip} cursor={"help"} extraStyle={{marginLeft: "0.125rem", fontSize: "0.5rem", verticalAlign: "super"}}>
        <SimpleModal title={modalTitle} isOpen={true} requestedSizing={'info-modal'}>
            {children}
        </SimpleModal>
    </ModalButton>
}

export default InfoModal;